import './Pill.scss';

export const Pill = ({ children, className = '', ...rest }) => {
    return (
        <div className={`Pill ${className}`} {...rest}>
            {children}
        </div>
    );
};